export default __webpack_public_path__ + "static/media/DarkBlue0002.e660dc33.png";